import { createElement, lazy } from "react"

export function renderLazy(
	importFn: () => Promise<any>,
	importName = "default",
) {
	const Lazy = lazy(() =>
		importFn().then((m) => ({ default: m[importName] })),
	)
	return createElement(Lazy)
}
